/* eslint-disable max-len */
// @flow
import { combineReducers } from 'redux';
import { ACTIONS, NOTIFICATION_SETTINGS_CHANNELS } from '../constants';
import type {
    NotificationSetting,
    NotificationSettingsLookup
} from '../constants';

export const notificationSettingsList = (
    state: Array<NotificationSettings> = [],
    action: {}
) => {
    switch (action.type) {
        case ACTIONS.NOTIFICATION_SETTINGS_LOADED:
            return [...action.settings];
        case ACTIONS.RESET_ALL:
            return [];
        default:
            return state;
    }
};

function notificationSettingsLookupGenerator(channel: string) {
    return (state: NotificationSettingsLookup = {}, action: any = {}) => {
        switch (action.type) {
            case ACTIONS.NOTIFICATION_SETTINGS_LOADED:
                return flattenArrayToSettingsObjectForType(
                    action.settings,
                    channel
                );
            case ACTIONS[`NOTIFICATION_SETTINGS_SET_${channel.toUpperCase()}`]:
                return {
                    ...state,
                    [action.key]: action.enabled
                };
            case ACTIONS[
                `NOTIFICATION_SETTINGS_SET_ALL_${channel.toUpperCase()}`
            ]:
                return setAllValues(state, action.enabled);
            case ACTIONS.RESET_ALL:
                return {};
            default:
                return state;
        }
    };
}

function flattenArrayToSettingsObjectForType(
    settings: Array<NotificationSetting>,
    classType: string
) {
    const lookup = {};
    for (const setting of settings) {
        if (setting[classType]) {
            lookup[setting[classType].key] = setting[classType].enabled;
        }
    }

    return lookup;
}

function setAllValues(state: NotificationSettingsLookup, value: boolean) {
    let newState = {};
    Object.keys(state).forEach((key: string) => (newState[key] = value));
    return newState;
}

export const notificationSettingsEmailLookup = notificationSettingsLookupGenerator(
    NOTIFICATION_SETTINGS_CHANNELS.EMAIL
);
export const notificationSettingsPushLookup = notificationSettingsLookupGenerator(
    NOTIFICATION_SETTINGS_CHANNELS.PUSH
);

export default combineReducers({
    notificationSettingsList,
    notificationSettingsEmailLookup,
    notificationSettingsPushLookup
});



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/state/notificationSettingsReducer.js